import React, {lazy} from 'react';
import { AuthRoute } from '../auth/components';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';

//import { TeamPage } from './pages';


const TeamPage = lazy(() => import('./pages/TeamPage'));

const teamModule = {
  routes: [<AuthRoute key="team" exact path="/team" component={TeamPage} headerType={'private'} />]
};
export default teamModule;
